export default class RSAencryption {
  static LinkingURL(linkURL, target) {
    window.open(linkURL, !!target ? target : '_blank');
  }
}

